export default class ContractItemModel {
  noContractTitle: string;
  descriptionTitle: string;
  returnButton: string;
}